export default "__VITE_PUBLIC_ASSET__2562ff55__"